import script from "./GraphFab.vue?vue&type=script&lang=ts&setup=true"
export * from "./GraphFab.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QFab,QFabAction});qInstall(script, 'directives', {TouchPan});
